import { useState, useEffect } from "react";
import axios from "axios";
import api from "../../../api";

const useProfessionalsData = (url, id, shopperId) => {
  const [professionalsData, setProfessionalsData] = useState([]);
  const [loadingProfessionals, setLoadingProfessionals] = useState(true);
  const [errorProfessionals, setErrorProfessionals] = useState(null);

  useEffect(() => {
    const fetchProfessionals = async () => {
      try {
        const response = await api.post(url, {
          shopper_id: shopperId,
          company_id: id
        });
        setProfessionalsData(response.data);
      } catch (err) {
        setErrorProfessionals (err);
      } finally {
        setLoadingProfessionals(false);
      }
    };
    fetchProfessionals();
  }, [id, shopperId]);

  return { professionalsData, loadingProfessionals, errorProfessionals };
};

export default useProfessionalsData;